<form [formGroup]="form" (ngSubmit)="onSubmit()" class="enroll-card md:max-w-4xl mx-auto">
  <div class="enroll-page-header">
    <h1>{{ headerTitle }}</h1>
    <p class="page-description">{{ headerSubtitle }}</p>
  </div>

  <section class="enroll-section">
    <div class="enroll-section-header">
      <mat-icon class="enroll-section-icon">person</mat-icon>
      <span>Enrollment Summary</span>
    </div>
    <div class="enroll-section-body">
      <h4 class="enroll-subhead">Primary Member</h4>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
        <div>
          <p class="enroll-label">Name</p>
          <p class="enroll-value">{{ memberData.firstName }} {{ memberData.middleName }} {{ memberData.lastName }}</p>
        </div>
        <div>
          <p class="enroll-label">Date of Birth</p>
          <p class="enroll-value">{{ memberData.dateOfBirth | date:'MM/dd/yyyy' }}</p>
        </div>
        <div>
          <p class="enroll-label">Email</p>
          <p class="enroll-value">{{ displayEmail }}</p>
        </div>
        <div *ngIf="memberData.mobilePhone">
          <p class="enroll-label">Mobile Phone</p>
          <p class="enroll-value">{{ memberData.mobilePhone | mask: '(000) 000-0000' }}</p>
        </div>
      </div>

      <div *ngIf="isPayrollDeducted && (memberData.primaryEmail || memberData.employeeId || memberData.hireDate)" class="mt-5 pt-4 border-t border-gray-200">
        <h4 class="enroll-subhead">Employment Information</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
          <div *ngIf="memberData.primaryEmail">
            <p class="enroll-label">Work Email</p>
            <p class="enroll-value">{{ memberData.primaryEmail }}</p>
          </div>
          <div *ngIf="memberData.employeeId">
            <p class="enroll-label">Employee ID</p>
            <p class="enroll-value">{{ memberData.employeeId }}</p>
          </div>
          <div *ngIf="memberData.hireDate">
            <p class="enroll-label">Hire Date</p>
            <p class="enroll-value">{{ memberData.hireDate | date:'MM/dd/yyyy' }}</p>
          </div>
        </div>
      </div>

      <div class="mt-5 pt-4 border-t border-gray-200">
        <h4 class="enroll-subhead">Home Address</h4>
        <p class="enroll-value">
          {{ memberData.homeAddress.address }}<br>
          {{ memberData.homeAddress.city }}, {{ memberData.homeAddress.state }} {{ memberData.homeAddress.zipCode }}
        </p>
      </div>

      <div class="mt-5 pt-4 border-t border-gray-200">
        <h4 class="enroll-subhead">Dependents</h4>
        <p *ngIf="!memberData.dependents || memberData.dependents.length === 0" class="enroll-muted">No dependents added</p>
        <div *ngFor="let dependent of memberData.dependents" class="text-sm text-gray-700 mb-1">
          {{ dependent.firstName }} {{ dependent.middleName }} {{ dependent.lastName }}
          · {{ dependent.dateOfBirth | date:'MM/dd/yyyy' }}
          · {{ dependent.relationship | titlecase }}
        </div>
      </div>
    </div>
  </section>

  <section class="enroll-section">
    <div class="enroll-section-header">
      <mat-icon class="enroll-section-icon">card_membership</mat-icon>
      <span>Selected Plans</span>
    </div>
    <div class="enroll-section-body">
      <app-plans-summary
        [products]="products"
        [paymentFrequency]="memberData.paymentFrequency"
        [discountApplied]="discountApplied">
      </app-plans-summary>
    </div>
  </section>

    <section class="enroll-section" *ngIf="!isPayrollDeducted">
      <div class="enroll-section-header">
        <mat-icon class="enroll-section-icon">credit_card</mat-icon>
        <span>Payment Details</span>
      </div>
      <div class="enroll-section-body" formGroupName="creditCard">
        <div class="grid grid-cols-6 md:gap-3 gap-2">
          <mat-form-field appearance="outline" class="w-full col-span-6 md:col-span-3 enroll-field">
            <mat-label>Card Number</mat-label>
            <input matInput type="text" formControlName="cardNumber" mask="0000 0000 0000 0099" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full col-span-2 md:col-span-1 enroll-field">
            <mat-label>Exp Month</mat-label>
            <input matInput type="text" formControlName="expiryMonth" mask="00" placeholder="MM" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full col-span-2 md:col-span-1 enroll-field">
            <mat-label>Exp Year</mat-label>
            <input matInput type="text" formControlName="expiryYear" mask="0000" placeholder="YYYY" [min]="currentYear" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full col-span-2 md:col-span-1 enroll-field">
            <mat-label>CVV</mat-label>
            <input matInput type="text" formControlName="cvv" mask="0009"/>
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="w-full mt-2 enroll-field">
          <mat-label>Cardholder's Name</mat-label>
          <input matInput type="text" formControlName="cardHolderName" />
        </mat-form-field>
      </div>
    </section>

    <div *ngIf="!isPayrollDeducted" class="px-5 pb-2">
      <mat-checkbox formControlName="isBillingSameAsHome">
        Use home address for billing
      </mat-checkbox>
    </div>

    <section class="enroll-section" *ngIf="!isPayrollDeducted && !form.get('isBillingSameAsHome')?.value">
      <div class="enroll-section-header">
        <mat-icon class="enroll-section-icon">home</mat-icon>
        <span>Billing Address</span>
      </div>
      <div class="enroll-section-body" formGroupName="billingAddress">
        <mat-form-field appearance="outline" class="w-full enroll-field">
          <mat-label>Address</mat-label>
          <input matInput type="text" formControlName="address" maxlength="200"/>
        </mat-form-field>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-3">
          <mat-form-field appearance="outline" class="w-full col-span-2 md:col-span-1 enroll-field">
            <mat-label>City</mat-label>
            <input matInput type="text" formControlName="city" maxlength="60" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full enroll-field">
            <mat-label>State</mat-label>
            <mat-select formControlName="state">
              <mat-option *ngFor="let state of states" [value]="state.key">
                {{ state.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full enroll-field">
            <mat-label>Zip Code</mat-label>
            <input matInput type="text" formControlName="zipCode" mask="00000" />
          </mat-form-field>
        </div>
      </div>
    </section>

    <section class="enroll-section" *ngIf="!isPayrollDeducted">
      <div class="enroll-section-header">
        <mat-icon class="enroll-section-icon">gavel</mat-icon>
        <span>Agreement</span>
      </div>
      <div class="enroll-section-body">
        <mat-checkbox formControlName="acceptTerms" class="terms-checkbox">
          <span class="text-sm text-gray-700">
            By checking this box, I agree to the
            <button type="button"
                    (click)="toggleTerms()"
                    class="text-[#1e3a5f] font-semibold hover:underline focus:outline-none">
              Membership Terms and Privacy Policy
            </button>
            and authorize recurring charges for the initial term and renewals.
          </span>
        </mat-checkbox>
        <div *ngIf="termsExpanded"
             class="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200 text-sm text-gray-700 leading-relaxed">
          <p class="mb-3">By enrolling, I agree to pay the monthly membership fee for a minimum of twelve (12) months. I understand that my membership is a 12-month commitment and will automatically renew each year on the anniversary of my enrollment unless Legal Resources is notified in writing at least 30 days prior to renewal.</p>
          <p class="mb-3">By submitting my payment information, I authorize Legal Resources to charge the account provided for the initial 12-month term and for each automatic renewal thereafter, unless I cancel in accordance with the cancellation policy.</p>
          <p>I acknowledge that Legal Resources is not a law firm, and that all legal services are provided by independent, participating attorneys in accordance with my plan documents.</p>
        </div>
        <div *ngIf="submitted && !form.get('acceptTerms')?.value" class="text-red-600 text-sm mt-2">
          You must accept the terms and conditions to continue
        </div>
        <div class="w-full mt-4">
            <p class="text-sm text-gray-500 mb-2">Please complete the security verification below.</p>
            <div id="turnstile-checkout"></div>
        </div>
      </div>
    </section>

    <div class="enroll-actions flex justify-between">
      <button type="button" (click)="onBack()" class="enroll-btn enroll-btn--secondary">Back</button>
      <button type="submit" class="enroll-btn enroll-btn--primary enroll-btn--inline">Complete Enrollment</button>
    </div>
</form>
